<template>
    <v-container :class="$mobile ? 'text-body-2' : 'text-body-1'" class="font-weight-light text-no-wrap bnft-time-counter">
        <div v-if="!end">
            <span v-if="!$mobile || ($mobile && days)">
                <number class="mx-n1" :to="days" easing="Power4.easeIn" />d<span v-if="!$mobile">:</span>
            </span>
            <number class="mx-n1" :to="hours" easing="Power4.easeIn" />h<span v-if="!$mobile">:</span>
            <number class="mx-n1" :to="minutes" easing="Power4.easeIn" />m<span v-if="!$mobile">:</span>
            <span v-if="!$mobile || ($mobile && !days)">
                <number class="mx-n1" :to="seconds" :duration="0" />s
            </span>
        </div>
        <div v-else style="color: #43a047; font-size: larger">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                        <span v-if="days > 0">
                            <number class="mx-n1" :to="days" easing="Power4.easeIn" v-if="!$mobile" /><span v-if="!$mobile">d<span v-if="!$mobile">:</span></span>
                        </span>
                        <span v-if="hours > 0">
                            <number class="mx-n1" :to="hours" easing="Power4.easeIn" />h<span v-if="!$mobile">:</span>
                        </span>
                        <number class="mx-n1" :to="minutes" easing="Power4.easeIn" />m<span v-if="!$mobile">:</span>
                        <number class="mx-n1" :to="seconds" />s
                    </div>
                </template>
                <span>Purchased  {{ new Date(end).toLocaleString() }}</span>
            </v-tooltip>
        </div>
    </v-container>
</template>
<style scoped>
.v-tooltip__content {
    color: black;
    background: white;
}
.bnft-time-counter {
    color: black;
}
</style>
<script>
import Vue from 'vue';
import VueNumber from '@667/vue-number-animation';

Vue.use(VueNumber);

const millisPerDay = 8.64e7;
const millisPerHour = 3.6e6;
const millisPerMinute = 60000;
const millisPerSecond = 1000;

export default {
    name: 'BnftTimeCounter',
    props: {
        start: {
            type: String,
            default: `${Date.now()}`,
        },
        end: String,
    },
    data: function () {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            interval: undefined,
        };
    },
    methods: {
        update() {
            const elapsed =
                (this.end ? Date.parse(this.end).valueOf() : Date.now()) -
                Date.parse(this.start).valueOf();
            const elapsedDays =
                elapsed > millisPerDay ? Math.floor(elapsed / millisPerDay) : 0;
            const elapsedHours =
                elapsed > millisPerHour
                    ? Math.floor((elapsed / millisPerHour) % 24)
                    : 0;
            const elapsedMinutes =
                elapsed > millisPerMinute
                    ? Math.floor((elapsed / millisPerMinute) % 60)
                    : 0;
            const elapsedSeconds =
                elapsed > millisPerSecond
                    ? Math.floor((elapsed / millisPerSecond) % 60)
                    : 0;
            this.days = elapsedDays;
            this.hours = elapsedHours;
            this.minutes = elapsedMinutes;
            this.seconds = elapsedSeconds;
            this.$emit('input', this);
        },
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    mounted() {
        const self = this;
        if (!self.end) {
            this.interval = setInterval(() => self.update(), 1000);
        } else {
            self.update();
        }
    },
};
</script>
